import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddAttribute } from '../../projectDetailsActivities.models';

export const AddAttributeActivity = ({ values }: IProjectActivity<IProjectActivityAddAttribute>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_AddAttribute')}
      <b>{values.attribute}</b>.
    </span>
  );
};
